import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash.isequal';
import { closeCurrentModal } from '@Header/ducks/operations';
import { openModal } from '@Header/Modals/ducks/actions';
import PromotionModal from './PromotionModal';
import {
  getCurrentModalName,
  getPromotionsWithModal
} from '../ducks/selectors';
import { ACCOUNT_MODAL } from '../../constants';
import { accountModalOperations } from './AccountModal/ducks';
import UserNotificationModal from './UserNotificationModal';
import { userNotificationSelectors } from '../UserNotifications/ducks';

class Modals extends PureComponent {
  componentDidUpdate(prevProps) {
    const { headerContextAccountModal } = this.props;
    const prevHeaderContextAccountModal = prevProps.headerContextAccountModal;
    const hasAccountModalContextChanged = !isEqual(headerContextAccountModal, prevHeaderContextAccountModal);

    if (hasAccountModalContextChanged) {
      this.props.openModal(ACCOUNT_MODAL, headerContextAccountModal);
    }
  }

  render() {
    const {
      closeCurrentModal: closeCurrentModalAction,
      currentModal,
      promotions,
      environment,
      userId,
      shouldShowUserNotificationModal,
      headerContextAccountModal
    } = this.props;

    return (
      <>
        {promotions.map(promotion => {
          const { name, modal, experiment } = promotion;
          if (name !== currentModal) {
            return null;
          }

          return (
            <PromotionModal
              key={name}
              {...modal}
              experiment={experiment}
              environment={environment}
              handleCloseModal={closeCurrentModalAction}
              userId={userId}
            />
          );
        })}

        {shouldShowUserNotificationModal && <UserNotificationModal />}
      </>
    );
  }
}

Modals.propTypes = {
  closeCurrentModal: PropTypes.func.isRequired,
  promotions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  environment: PropTypes.string.isRequired,
  openModal: PropTypes.func.isRequired,
  goToCreateAccountTab: PropTypes.func.isRequired,
  goToResetPasswordTab: PropTypes.func.isRequired,
  goToForgotPasswordTab: PropTypes.func.isRequired,
  goToSignInTab: PropTypes.func.isRequired,
  shouldShowUserNotificationModal: PropTypes.bool.isRequired,
  headerContextAccountModal: PropTypes.shape({}),
  currentModal: PropTypes.string,
  userId: PropTypes.string
};

Modals.defaultProps = {
  headerContextAccountModal: {},
  currentModal: null,
  userId: ''
};

const mapStateToProps = state => ({
  currentModal: getCurrentModalName(state),
  promotions: getPromotionsWithModal(state),
  shouldShowUserNotificationModal:
    !getCurrentModalName(state) &&
    Boolean(userNotificationSelectors.getUserNotificationModal(state))
});

const mapDispatchToProps = dispatch => ({
  closeCurrentModal: () => dispatch(closeCurrentModal()),
  openModal: (modalName, headerContextAccountModal) => dispatch(openModal(modalName, headerContextAccountModal)),
  goToCreateAccountTab: () =>
    dispatch(accountModalOperations.goToCreateAccountTab()),
  goToResetPasswordTab: () =>
    dispatch(accountModalOperations.goToResetPasswordTab()),
  goToForgotPasswordTab: () =>
    dispatch(accountModalOperations.goToForgotPasswordTab()),
  goToSignInTab: () =>
    dispatch(accountModalOperations.goToSignInTab())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Modals);
